import { jsx as e } from "react/jsx-runtime";
import { CircleIcon as o, CircleCheckIcon as s, CircleXMarkIcon as i } from "../../icons/componentIcons.mjs";
const n = ({
  status: c,
  ...r
}) => {
  const a = "password-requirement-status-icon";
  switch (c) {
    case "error":
      return /* @__PURE__ */ e(
        i,
        {
          variant: "solid",
          color: "red.500",
          className: a,
          "aria-label": "x mark",
          ...r
        }
      );
    case "success":
      return /* @__PURE__ */ e(
        s,
        {
          variant: "solid",
          color: "green.500",
          className: a,
          "aria-label": "check mark",
          ...r
        }
      );
    default:
      return /* @__PURE__ */ e(o, { variant: "light", color: "gray.500", className: a, ...r });
  }
};
export {
  n as PasswordRequirementStatusIcon
};
